import { FormattedMessage } from 'react-intl';

import type { IncidentResolution } from '@/lib/queries/rca/incidentResolutions';

// export const getStatusIcon = (status: Incident['status']): JSX.Element => {
//   switch (status) {
//     case 'completed':
//       return <CheckCircle className="w-5 h-5 text-green-500" />;
//     case 'in_progress':
//       return <Play className="w-5 h-5 text-blue-500 animate-pulse" />;
//     case 'failed':
//       return <XCircle className="w-5 h-5 text-red-500" />;
//     case 'pending':
//       return <Clock className="w-5 h-5 text-gray-400" />;
//     default:
//       return <AlertCircle className="w-5 h-5 text-yellow-500" />;
//   }
// };

// export const getStatusColor = (status: RCAStep['status']): string => {
//   switch (status) {
//     case 'completed':
//       return 'border-green-500 bg-green-50 dark:bg-green-900/20';
//     case 'in_progress':
//       return 'border-blue-500 bg-blue-50 dark:bg-blue-900/20';
//     case 'failed':
//       return 'border-red-500 bg-red-50 dark:bg-red-900/20';
//     case 'pending':
//       return 'border-gray-300 bg-gray-50 dark:bg-gray-800/50 dark:border-gray-600';
//     default:
//       return 'border-yellow-500 bg-yellow-50 dark:bg-yellow-900/20';
//   }
// };

export const getRCAStatusBadge = (
  status: IncidentResolution['status'],
): JSX.Element | null => {
  const baseClasses = 'px-3 py-1 rounded-full text-sm font-medium';

  switch (status) {
    case 'completed':
      return (
        <span
          className={`${baseClasses} bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400`}
        >
          <FormattedMessage id="rca.investigationStatus.completed" />
        </span>
      );
    case 'in_progress':
      return (
        <span
          className={`${baseClasses} bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400`}
        >
          <FormattedMessage id="rca.investigationStatus.investigating" />
        </span>
      );
    case 'failed':
      return (
        <span
          className={`${baseClasses} bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400`}
        >
          <FormattedMessage id="rca.investigationStatus.failed" />
        </span>
      );
    case 'timeout':
      return (
        <span
          className={`${baseClasses} bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400`}
        >
          <FormattedMessage id="rca.investigationStatus.timeout" />
        </span>
      );
    default:
      return null;
  }
};

export const formatDuration = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds}s`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return remainingSeconds > 0
    ? `${minutes}m ${remainingSeconds}s`
    : `${minutes}m`;
};

export const formatTime = (timestamp: string): string => {
  return new Date(timestamp).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};
